import React, { useState } from 'react'
import { InputError, Action, Spinner } from '@foodsby/nutrient'
import { copyToClipboard } from '../../util/formatUtils'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
import { useMyReferralWithEnabledDetails } from '../../hooks/referral'

export const CopyReferral = () => {
  const [copied, setCopied] = useState(false)

  const {
    referralAndEnabledDetails,
    referralCopiedText,
    loading,
    error,
  } = useMyReferralWithEnabledDetails()

  return (
    <>
      <label className="referral-label">Refer and Earn</label>
      <div className="referral-container referral">
        <div className="share-container">
          <span className="link-visible referral-link">
            {loading ? (
              <Spinner className="spinner-xs secondary" />
            ) : (
              referralAndEnabledDetails?.referral?.shareUrl
            )}
          </span>
          <Action
            className="copy-referral"
            disabled={loading}
            onClick={() => {
              setCopied(true)
              copyToClipboard(referralCopiedText)
              pushAnalyticsEvent('Referral', 'Copy Referral')
              if (window.appboy) {
                window.appboy.logCustomEvent('referral-copied-link')
              }
            }}
            style={{ textTransform: 'uppercase' }}
          >
            Copy
          </Action>
        </div>
        {copied && (
          <p className="copied-text">
            Copied. Now go share via email, Slack, Teams, text, and more.
          </p>
        )}
        {error && (
          <div className="error-container">
            <InputError>{error}</InputError>
          </div>
        )}
      </div>
    </>
  )
}
